import React, { ReactNode } from 'react'
import Typography from '../../Typography'

interface ITitleProps {
  children: ReactNode
}

function Title(props: ITitleProps) {
  const { children } = props
  return (
    <Typography variant="caption" size="l" bold>
      {children}
    </Typography>
  )
}

Title.displayName = 'MessageBox.Title'

export { Title }
